import * as React from 'react';

import styles from './codetable-item-row.scss';

export interface CodetableItemRowProps {
  isZebra?: boolean;
  treeDepthLevel?: number;
  isLoader?: boolean;
  children?: React.ReactNode;
}

export const CodetableItemRow: React.FC<CodetableItemRowProps> = ({ children, isZebra, treeDepthLevel, isLoader }) =>
  <div className={`${styles.codeRow} ${isZebra ? styles.zebra : ''} ${isLoader ? styles.isLoader : ''}`}
    style={{ paddingLeft: `calc(8px + 40px*${treeDepthLevel})` }}>
    {children}
  </div>;
